import './ActionContainer.css';

import { Button } from '@nike/eds';
import { useDispatch, useSelector } from 'react-redux';
import { MonthSelection } from '../month_selection/MonthSelection';
import { LocalClearanceBatch } from '../../shared/Types';
import { StoreDispatch } from '../../shared/store/Store';
import { selectCheckedBatches, toggleModalConfirmation, toggleFlushFilingPacksModal } from '../../shared/store/reducers/OverviewReducer';
import { useRoles } from '../../shared/user/userRolesAccessManagement';

export function ActionContainer() {
    const dispatch: StoreDispatch = useDispatch();
    const batches = useSelector(selectCheckedBatches) as LocalClearanceBatch[];
    const { hasRole } = useRoles();

    const onClickDeclare = () => {
        dispatch(toggleModalConfirmation(true));
    }

    const onClickCreateSendAllFilingPacks = () => {
        dispatch(toggleFlushFilingPacksModal(true));
    }

    return (
        <div id="action-container">
            <MonthSelection/>

            <div id="action-button-container">
                <span className="eds-type--body-3">{batches.length} items selected</span>
                
                <Button id="submit-button" onClick={onClickDeclare} disabled={batches.length === 0}>
                    Release enriched EiDRs for selected batch(es)
                </Button>

                {hasRole('technicalSupportUser') && (
                    <Button id="flush-fp-button" onClick={onClickCreateSendAllFilingPacks} className="left-space">
                        Create and send all filing packs
                    </Button>
                )}
            </div>
        </div>
    )
}